export default (obj) => {
	const keys = Object.keys(obj);
	const priority = keys.filter(item => obj[item].hasOwnProperty('priority'));
	const other = keys.filter(item => !obj[item].hasOwnProperty('priority')).sort();

	return priority.sort((a, b) => obj[a].priority - obj[b].priority).concat(other);
};



// WEBPACK FOOTER //
// ./frontend/shared/js/sort.js